/* Latif's Jewelry: scroll reveal and first-visit intro */
(function () {
  /* Booking and other outside links open in a new tab so shoppers don't lose the site */
  function newTabs() {
    document.querySelectorAll('a[href*="calendly.com"], a[href*="wa.me"], a[href*="instagram.com"]').forEach(function (a) {
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', newTabs);
  } else {
    newTabs();
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  if (reduce || editor) return;

  if (!('IntersectionObserver' in window)) return;

  function init() {
    var single = document.querySelectorAll(
      '.lj-section-head, .lj-row-head, .lj-spot__text, .lj-spot__media, .lj-story__text, .lj-story__media, .lj-visit, .lj-hero--compact .lj-hero__text, .lj-show__media, .lj-show__text'
    );
    var groups = document.querySelectorAll('.lj-cats, .lj-prices, .lj-gemindex, .lj-promises, .lj-reviews, .lj-cp__grid');
    var targets = [];

    single.forEach(function (el) { targets.push(el); });
    groups.forEach(function (list) {
      Array.prototype.forEach.call(list.children, function (item, i) {
        item.style.setProperty('--lj-delay', Math.min(i, 8) * 90 + 'ms');
        targets.push(item);
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    targets.forEach(function (el) {
      /* Anything already on screen at load just shows, no flash */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('is-in'); return; }
      el.classList.add('lj-reveal');
      io.observe(el);
    });

    rows();
    cards();
  }

  /* New arrivals and other rows: pieces sweep in, then swell as they pass the middle */
  function rows() {
    document.querySelectorAll('ul.lj-row').forEach(function (row) {
      function number() {
        var n = 0;
        Array.prototype.forEach.call(row.children, function (li) {
          if (!li.hasAttribute('data-lj-clone')) li.style.setProperty('--i', Math.min(n++, 6));
        });
      }
      number();

      var r0 = row.getBoundingClientRect();
      var hidden = row.classList.contains('lj-loading');
      if (hidden || r0.top > window.innerHeight * 0.9) {
        row.classList.add('lj-arrive');
        var go = function () {
          if (row.classList.contains('lj-loading')) return;
          var r = row.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
            number();
            row.classList.add('is-in');
            window.removeEventListener('scroll', go);
            clearInterval(poll);
          }
        };
        var poll = setInterval(go, 150);
        window.addEventListener('scroll', go, { passive: true });
        row.addEventListener('lj:items', function () { number(); setTimeout(go, 50); });
        setTimeout(function () { clearInterval(poll); }, 20000);
        go();
      }

      row.classList.add('lj-depth');
      var items = [];
      var collect = function () { items = Array.prototype.slice.call(row.children); };
      collect();
      new MutationObserver(collect).observe(row, { childList: true });
      var on = true;
      new IntersectionObserver(function (e) { on = e[0].isIntersecting; }).observe(row);
      (function frame() {
        if (on && !document.hidden) {
          var rb = row.getBoundingClientRect();
          var mid = rb.left + rb.width / 2;
          var half = rb.width / 2 || 1;
          for (var i = 0; i < items.length; i++) {
            var b = items[i].getBoundingClientRect();
            if (b.right < rb.left - 40 || b.left > rb.right + 40) continue;
            var d = Math.min(Math.abs(b.left + b.width / 2 - mid) / half, 1);
            items[i].style.setProperty('--lj-d', (d * d).toFixed(3));
          }
        }
        requestAnimationFrame(frame);
      })();
    });
  }

  /* Shop pages, search and "You may also love": pieces rise in row by row */
  function cards() {
    var list = document.querySelectorAll('ul.product-grid:not(.lj-row) > .grid__item');
    if (!list.length) return;
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io2.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(list, function (li, i) {
      var r = li.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) return;
      li.style.setProperty('--lj-delay', (i % 4) * 90 + 'ms');
      li.classList.add('lj-card-in');
      io2.observe(li);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
